import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { GetProvizyonRequest, SapProvizyonGroupedResponseModel } from '../models'

export class GetProvizyonApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'MyReports/GetProvizyon',
      requesterInfo,
    })
  }

  public async getProvizyon(request: GetProvizyonRequest): Promise<SapProvizyonGroupedResponseModel[]> {
    return await this.postAsync<SapProvizyonGroupedResponseModel[]>(request)
  }
}
